// extracted by mini-css-extract-plugin
export default {"item":"PartnersSlider_item__z5kfS"};